export const validTagImg = new RegExp("<img.+?src=.*?>");
export const validTitle = new RegExp("^[A-Za-z0-9 ()_,.-]*$");
export const validTitleAlert = new RegExp('^[A-Za-z0-9 ()_,.&\'"-]*$');
